import { useNavigate } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

function Contact(){
    const navigate = useNavigate();

    return(
        <div className='page-wrapper'>
            <NavBar/>
            <main>
                <div className='contact-div'>
                    <div className='contact-sub-div' >
                        
                        <div className='contact-middle' >
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1428.1969429684964!2d-113.50988209199767!3d53.459904877206945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53a01f1e27f5d553%3A0xfecfea20458b6890!2sOSSEO%20Dental%20Prosthetics!5e1!3m2!1sen!2sca!4v1761526691060!5m2!1sen!2sca" style={{width: '150%', minHeight: '450px', marginLeft: '-25%'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"/>
                        </div>
                    </div>
                </div>
                
                
                <hr/>
                <div className='contact-bottom' >
                    <div>
                        <h2>Contact Us</h2>
                        <hr/>
                        <div>
                            <div>
                                <h3>Call Us</h3>
                                
                                <p><FaPhoneAlt/> 780 - 469 - 7757</p>
                            </div>
                            <div>
                                <h3>Email</h3>
                                
                                <p><MdEmail/> osseodentpro@gmail.com</p>
                            </div>
                            {/* <div>
                                <h3>Owner</h3>
                                
                                <p><MdEmail/> osseodentpro@gmail.com</p>
                            </div> */}
                        </div>
                    </div>
                    <div>
                        <h2>Lab Address</h2>
                        <hr/>
                        <p>#115, 2841 - 109 Street NW</p>
                        <p>Edmonton, Alberta T6J 6B7</p>
                    </div>
                    <div>
                        <h2>Ask For a Start-Up Supply Kit</h2>
                        <hr/>
                        <ul>
                            <li>Boxes</li>
                            <li>Bags</li>
                            <li>Rx Pad</li>
                            <li>Business Cards</li>
                        </ul>
                        <p>Call us and we will send it right over!</p>
                    </div>
                </div>
                
            </main>
            <Footer/>
        </div>
        
    )
}
export default Contact;